import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SketchCircleFilledSvg from "@ant-design/icons-svg/es/asn/SketchCircleFilled";
import AntdIcon from '../components/AntdIcon';
var SketchCircleFilled = function SketchCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: SketchCircleFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(SketchCircleFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'SketchCircleFilled';
}
export default RefIcon;